<div *ngFor="let group of documents; let i = index" class="card card-accent-primary shadowed">
  <div class="card-header">
    <i class="fa fa-user"></i>
    <strong>{{group.name}}</strong>
  </div>
  <div class="card-block media-card">
    <div class="row">
      <div
        class="col-sm-4 col-lg-3"
        style="display: block;"
        *ngFor="let file of group.contents; let i = index"
      >
        <div
          class="media-items animation-fadeInQuick2"
          data-category="pdf"
          (click)="download(file.path, file.name)"
        >
          <div *ngIf="file.name.indexOf('pdf') > -1" class="media-items-content">
            <i class="fa fa-file-pdf-o fa-5x text-danger"></i>
          </div>
          <div *ngIf="file.name.indexOf('xl') > -1" class="media-items-content">
            <i class="fa fa-file-excel-o fa-5x text-success"></i>
          </div>
          <div *ngIf="file.name.indexOf('csv') > -1" class="media-items-content">
            <i class="fa fa-file-excel-o fa-5x text-success"></i>
          </div>
          <div *ngIf="file.name.indexOf('doc') > -1" class="media-items-content">
            <i class="fa fa-file-word-o fa-5x text-info"></i>
          </div>
          <div *ngIf="file.name.indexOf('txt') > -1" class="media-items-content">
            <i class="fa fa-file-text-o fa-5x text-warning"></i>
          </div>
          <p style="word-wrap: break-word;">
            <strong>{{file.name | slice:0:50 }}</strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
